export default __webpack_public_path__ + "static/media/read.ac1e5f00.svg";